import type { DownloadFileActionConfig, DownloadFileActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { type ActionFlowNode, downloadFile, resolveDownloadFileUrls, waitFor } from '@lighthouse/shared'
import { t } from 'i18next'

import type { ExecuteActionParams } from '../type'

export const handleDownloadFileStream = async (
    node: ActionFlowNode<DownloadFileActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }

    await handleDownloadFile(config, params)

    return { type: 'record', success: true }
}

export const handleDownloadFile = async (config: DownloadFileActionConfig, params: ExecuteActionParams) => {
    const downloadFileParams = resolveDownloadFileUrls(config, params)

    if (downloadFileParams) {
        await downloadFile(downloadFileParams)

        await waitFor(1000)
    }

    return downloadFileParams
}
